<template lang="pug">
  .module__main
    .module__title Список пополнений
    .module-content__container
      .filters__container
        .dates__container
          .date__container
            el-date-picker(
              v-model="date"
              type="datetimerange"
              range-separator="-"
              start-placeholder="От"
              end-placeholder="До"
              :picker-options="dateOptions"
            )
        .search__container
          el-select(v-model="searchMode" @change="updateDefaultSearchMode()")
            el-option(v-for="(mode, key) in searchModes" :key="`search-mode-${key}`" :label="mode.locale" :value="key")
          el-input(v-model="searchValue" :placeholder="searchModes[searchMode].title")
            i.el-input__icon.el-icon-search(slot="suffix" @click="searchOrder()")
          i.el-icon-close.search-reset__btn(v-if="searchLoaded" @click="resetSearch()")
      .table__container
        .table-list__container
          el-table(
            v-loading="isLoading"
            :data="formattedDeposits"
            style="width: 100%; font-size: 12px"
          )
            el-table-column(v-if="isAdmin || isSupport" prop="user" label="Пользователь" width="200")
            el-table-column(prop="address" label="Адрес" width="300")
            el-table-column(prop="amount" label="Количество" width="100")
            el-table-column(prop="date" label="Дата" width="140")
            el-table-column(prop="txid" label="ID транзакции" width="250")
              template(v-slot:default="scope" )
                a(:href="scope.row.txidLink" target="_blank") {{ scope.row.txid }}
        .table-pagination__container
          el-pagination(
            style="margin-top: 20px"
            v-if='hasPagination',
            :total='deposits.pagination.total',
            :page-size="per_page",
            :current-page='deposits.pagination.page',
            background,
            layout='prev, pager, next',
            @current-change='loadDeposits',
          )
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { LOAD_DEPOSITS_LIST } from "@/store/const/deposits";

export default {
  name: 'Deposits',
  data() {
    return {
      page: 1,
      per_page: 50,
      searchValue: '',
      searchLoaded: false,
      searchMode: localStorage.getItem('deposits_searchMode') || 'txid',
      intervalHandle: null,
      isFirstLoading: true,
      date: '',
      dateOptions: {
        shortcuts: [{
          text: 'Сегодня',
          onClick(picker) {
            const start = new Date();
            const end = new Date();
            start.setHours(0, 0, 0, 0);
            end.setHours(23, 59, 59, 999);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: 'Сутки',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: 'Вчера',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setDate(start.getDate() - 1);
            start.setHours(0, 0, 0, 0);
            end.setDate(end.getDate() - 1);
            end.setHours(23, 59, 59, 999);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: 'Неделя',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: 'Месяц',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '3 месяца',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
    }
  },
  async mounted() {
    await this.loadDeposits();
    this.isFirstLoading = false;
    this.startInterval();
  },
  beforeDestroy() {
    clearInterval(this.intervalHandle);
  },
  computed: {
    ...mapGetters([
      'loading',
      'error',
    ]),
    ...mapGetters('deposits', [
      'deposits',
    ]),
    ...mapGetters('settings', [
      'cryptoType',
    ]),
    ...mapGetters('user', [
      'isAdmin',
      'isSupport',
      'username',
    ]),
    isLoading() {
      return this.isFirstLoading && this.loading(LOAD_DEPOSITS_LIST) === 'loading';
    },
    isError() {
      return this.loading(LOAD_DEPOSITS_LIST) === 'error';
    },
    errorMessage() {
      return this.error(LOAD_DEPOSITS_LIST);
    },
    hasPagination() {
      return this.deposits.pagination.total > this.per_page;
    },
    searchModes() {
      const modes = {
        txid: { locale: 'По транзакции', title: 'ID транзакции' },
        address: { locale: 'По кошельку', title: 'Адрес кошелька' },
      }
      return modes;
    },
    dates() {
      if (Array.isArray(this.date)) {
        const from = new Date(this.date[0]);
        const to = new Date(this.date[1]);
        from.setMinutes(from.getMinutes() - from.getTimezoneOffset()); // SET TO UTC 0
        to.setMinutes(to.getMinutes() - to.getTimezoneOffset()); // SET TO UTC 0
        from.setMinutes(from.getMinutes() - 180); // SET TO UTC +3
        to.setMinutes(to.getMinutes() - 180); // SET TO UTC +3
        return {
          from: from.getTime(),
          to: to.getTime(),
        }
      } else {
        return null;
      }
    },
    formattedDeposits() {
      return this.deposits.list.map((deposit) => {
        const date = new Date(deposit.date);
        return {
          ...deposit,
          date: date.toLocaleString(),
          txidLink: `https://live.blockcypher.com/${this.cryptoType.toLowerCase()}/tx/${deposit.txid}/`
        }
      })
    }
  },
  methods: {
    ...mapActions('deposits', {
      loadDepositsList: LOAD_DEPOSITS_LIST,
    }),
    startInterval() {
      this.intervalHandle = setInterval(() => this.loadDeposits(this.page), 10000);
    },
    async loadDeposits(page = 1) {
      if (this.isLoading) {
        return;
      }
      const params = {
        page,
        per_page: this.per_page,
      }
      if (this.searchValue) {
        params[this.searchMode] = this.searchValue;
      }
      if (this.date) {
        params.from = this.dates.from;
        params.to = this.dates.to;
      }
      await this.loadDepositsList({ params });
      this.page = page;
      this.searchLoaded = !!this.searchValue;
    },
    async searchOrder() {
      clearInterval(this.intervalHandle);
      this.searchValue = this.searchValue.trim();
      await this.loadDeposits(1);
    },
    resetSearch() {
      this.searchLoaded = false;
      this.searchValue = '';
      this.loadDeposits();
      this.startInterval();
    },
    updateDefaultSearchMode() {
      localStorage.setItem('deposits_searchMode', this.searchMode);
    },
  }
};
</script>
<style scoped>
.filters__container {
    margin-bottom: 5px;
    display: flex;
    justify-content: space-between;
    border: 1px solid #c9c9c9;
}

.search__container {
    display: flex;
    justify-content: center;
    align-items: flex-end;
    margin-left: auto;
}

.search-reset__btn {
    padding: 11px;
    background-color: #e95050;
    cursor: pointer;
}

.search-reset__btn:hover {
    padding: 10px;
    background-color: #dd3636;
    border: 1px solid #850202;
}

.search__container .el-select {
    width: 250px;
}

.dates__container {
    display: flex;
    align-items: center;
}

.date__container {
    margin: 0 5px;
    display: flex;
    justify-content: center;
    align-items: center;
}
</style>
